export default __webpack_public_path__ + "static/b1-c475e56343938f1da4e88d4a9d37ea26.png";